import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "supplier-questions-group-select";

const keys = addTranslations(RESOURCE_NAME, {
    group_not_translated: {
        en: "Translation not available",
        fr: "Traduction non disponible",
    },
    new_group: {
        en: "New section",
        fr: "Nouvelle section",
    },
    modal_title: {
        en: "New section",
        fr: "Nouvelle section",
    },
    modal_edit_title: {
        en: "Edit section",
        fr: "Modifier la section",
    },
    modal_delete_title: {
        en: "Delete section",
        fr: "Supprimer la section",
    },
    modal_english_name: {
        en: "English name",
        fr: "Nom en anglais",
    },
    modal_french_name: {
        en: "French name",
        fr: "Nom en français",
    },
    modal_name_already_exists: {
        en: "Name already exists",
        fr: "Le nom existe déjà",
    },
    modal_name_required: {
        en: "Name is required",
        fr: "Le nom est requis",
    },
    modal_delete_group_label: {
        en: "Delete section",
        fr: "Supprimer la section",
    },
    delete_group_label_description: {
        en: "This will delete the section from all the associated questions.",
        fr: "Cela supprimera la section de toutes les questions associées.",
    },
    modal_delete_body: {
        en: "Are you sure you want to delete this section? This action is irreversible. Please note, the section will still appear in any questionnaires that have already been sent.",
        fr: "Êtes-vous sûr de vouloir supprimer cette section ? Cette action est irréversible. Veuillez noter que la section apparaîtra encore dans tous les questionnaires qui ont déjà été envoyés.",
    },
    modal_cancel: {
        en: "Cancel",
        fr: "Annuler",
    },
    modal_save: {
        en: "Save",
        fr: "Enregistrer",
    },
    modal_delete: {
        en: "Delete",
        fr: "Supprimer",
    },
    modal_toast_error_edit_question_group: {
        en: "There was an error editing the question section",
        fr: "Il y a eu une erreur lors de la modification de la section de questions",
    },
    modal_toast_error_delete_question_group: {
        en: "There was an error deleting the question section",
        fr: "Il y a eu une erreur lors de la suppression de la section de questions",
    },
});

export function useSupplierQuestionsGroupSelectTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
